export default __webpack_public_path__ + "static/media/nantes6.cb4248d9.jpg";